import React from "react";
import { Box, Grid, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import {
    NoteAlt as WorkOrderIcon,
    PrecisionManufacturing as EquipmentIcon,
    ListAlt as BOMIcon,
    QrCodeScanner as ScanIcon,
    Search as SearchIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const shopItems = [
    {
        title: "Work Orders",
        desc: "View work orders and complete traveler steps.",
        path: "/shop/work-orders",
        icon: WorkOrderIcon,
    },
    {
        title: "Equipment",
        desc: "Perform daily, weekly, and monthly equipment checks.",
        path: "/shop/equipment",
        icon: EquipmentIcon,
    },
    {
        title: "Bill of Materials",
        desc: "View BOM status and stock pull progress by project.",
        path: "/shop/bom",
        icon: BOMIcon,
    },
    {
        title: "Scan QR",
        desc: "Scan a traveler or BOM QR code to view it.",
        path: "/scan",
        icon: ScanIcon,
    },
    {
        title: "Find Material",
        desc: "Look up a raw material or assembly by part number.",
        path: "/shop/material/search",
        icon: SearchIcon,
    },
];

export default function Shop() {
    const navigate = useNavigate();

    return (
        <Box>
            <Grid container spacing={2}>
                {shopItems.map(({ title, desc, path, icon: Icon }) => (
                    <Grid item xs={6} key={path}>
                        <Card
                            sx={{
                                height: "100%",
                                boxShadow: "none",
                                border: 1,
                                borderColor: "primary.main",
                            }}
                        >
                            <CardActionArea
                                onClick={() => navigate(path)}
                                sx={{ height: "100%", alignItems: "flex-start" }}
                            >
                                <CardContent>
                                    <Box sx={{ mb: 1 }}>
                                        <Icon color="primary" fontSize="medium" />
                                    </Box>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            lineHeight: 1.3,
                                            mb: 0.5,
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {desc}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
